module.exports = __webpack_public_path__ + "img/pl-PL-add-to-apple-wallet.e1f888a.svg";